import React from "react";
import {PageHeader} from "./PageHeader";
import logoKrakow from "../img/sponsors/logo-krakow3.jpg";
import mapa0 from "../img/mapa0.png";
import mapa1 from "../img/mapa1.png";
import mapa2 from "../img/mapa2.png";
import mapa3 from "../img/mapa3.png";

export const Place = props => {
    return (
        <React.Fragment>
            <PageHeader title="Miejsce"/>
            <div className="content-wrapper">
                <div className="main-content">
                    <div className="row">
                        <div className="col text-center">
                            <h2>Miło nam poinformować, że Miasto Kraków przyjęło tytuł <br/> "Miasta Gospodarza Zjazdu".</h2>
                            <a href="https://business.krakow.pl/"><img src={logoKrakow} alt="Miasto Kraków"/></a>
                        </div>
                    </div>
                    <h2 className="my-4">Lokalizacje:</h2>
                    <div className="row">
                        <div className="col">
                            <b>13-15.09.2019</b> <br/>
                            Auditorium Maximum Uniwersytetu Jagiellońskiego, ul. Krupnicza 33,
                            Kraków
                        </div>
                        <div className="col">
                            <b>16.09.2019</b> <br/>
                            Akademia Górniczo-Hutnicza
                            <br/>
                            ul. Budryka 4 (Klub Studio), Kraków (sesja plenarna)
                            <br/>
                            ul. Reymonta 19, pawilon D-10, Kraków (sesje równoległe)
                            <br/>
                            ul. Kawiory 30, pawilon D-16, Kraków (sesje równoległe)
                        </div>
                        <div className="col">
                            <b>17-18.09.2019</b> <br/>
                            Wydział Fizyki, Astronomii i Informatyki Stosowanej UJ ul. Prof.
                            St. Łojasiewicza 11, Kraków
                        </div>

                    </div>
                </div>
                <hr/>
                <div className="main-content">
                    <h2>Miejsca poszczególnych sesji oraz wydarzeń</h2>
                    <div>
                        <figure className="row">
                            <div className="col">
                                <img src={mapa0} width="632px" alt="Mapa"/>
                            </div>
                            <figcaption className="col d-flex align-items-center">
                                Zjazd odbędzie się kolejno w trzech rejonach Krakowa. Rejestracja i pierwsza
                                część w Auditorium Maximum UJ (niedaleko Rynku),
                                następnie w poniedziałek na jeden dzień przenosimy się na pobliski teren Akademii
                                Górniczo-Hutniczej.
                                Ostatnie dwa dni zaplanowano na III Kampusie UJ na obrzeżach Krakowa.
                            </figcaption>
                        </figure>
                    </div>
                    <div>
                        <figure className="row">
                            <div className="col">
                                <img src={mapa1} width="632px" alt="Mapa"/>
                            </div>
                            <figcaption className="col d-flex align-items-center">
                                12-15 września 2019 (czwartek – niedziela)
                                Auditorium Maximum UJ, ul. Krupnicza 33, Kraków
                            </figcaption>
                        </figure>
                    </div>
                    <div>
                        <figure className="row">
                            <div className="col">
                                <img src={mapa2} width="632px" alt="Mapa"/>
                            </div>
                            <figcaption className="col d-flex align-items-center">
                                16 września 2019 (poniedziałek) Dzień w AGH
                                Klub Studio (sesja plenarna),
                                ul. Budryka 4, Kraków, https://www.klubstudio.pl/
                                Pawilon D-10 (sesje równoległe),
                                Wydział Fizyki i Informatyki Stosowanej AGH, ul. Reymonta 19, Kraków
                                Pawilon D-16 (sesje równoległe),
                                Akademickie Centrum Materiałów i Nanotechnologii AGH (ACMIN), ul. Kawiory 30, Kraków
                            </figcaption>
                        </figure>
                    </div>
                    <div>
                        <figure className="row">
                            <div className="col">
                                <img src={mapa3} width="632px" alt="Mapa"/>
                            </div>
                            <figcaption className="col d-flex align-items-center">
                                17-18 września 2019 (wtorek, środa) III Kampus UJ
                                Budynek WFAIS,
                                Wydział Fizyki, Astronomii i Informatyki Stosowanej UJ, ul. prof. St. Łojasiewicza 11,
                                Kraków
                            </figcaption>
                        </figure>
                    </div>
                </div>
                <div className="clearfix"></div>
            </div>
        </React.Fragment>
    );
};

Place.propTypes = {};
